var waitForJQuery = setInterval(function () {
  if (typeof $ != 'undefined') {
    
window.addEventListener("load", (event) => {
    $( "article img" ).each(function() {

var $img = $(this);
var ratio = $img.height() / $img.width();

if ( ratio <= 0.75 ) { 
  $img.addClass(`wideimg ${ratio}`);
}  
});


var lastimg = $( ".publishdetails" ).prev().find('img').length;

  if(lastimg == 0) {
    $('.publishdetails').css('margin-top','50px');
  }

  
});

          clearInterval(waitForJQuery);
  }
}, 10);